import styled from 'styled-components';
import { KOALA } from 'HubStyleTokens/colors';
export const StyledGoogleOAuthButton = styled.div.withConfig({
  displayName: "GoogleOAuthButtonstyles__StyledGoogleOAuthButton",
  componentId: "choey-0"
})(["display:flex;justify-content:center;height:40px;"]);
export const StyledGoogleIdentityServicesLoading = styled.div.withConfig({
  displayName: "GoogleOAuthButtonstyles__StyledGoogleIdentityServicesLoading",
  componentId: "choey-1"
})(["height:40px;background:", ";"], KOALA);
export const StyledGoogleIdentityServicesLoadingContainer = styled.div.withConfig({
  displayName: "GoogleOAuthButtonstyles__StyledGoogleIdentityServicesLoadingContainer",
  componentId: "choey-2"
})(["display:flex;justify-content:center;"]);